import {
  addItemToCollection,
  deleteItemFromCollection,
  getItemsFromCollection,
  getItemFromCollection,
  updateItemInCollection,
} from "directus/src/operations";
import { filter } from "lodash";

export async function createJobEmployee(data) {
  try {
    const response = await addItemToCollection("jobs_employees", data);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function removeEmployeeFromJob(id) {
  try {
    const response = await deleteItemFromCollection("jobs_employees", id);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function restrictEmployeeLogging(id, isRestricted = true) {
  try {
    const response = await updateItemInCollection("jobs_employees", id, {
      is_logging_restricted: isRestricted,
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function toggleEmployeeShadowMode(id, isShadow = true) {
  try {
    const response = await updateItemInCollection("jobs_employees", id, {
      is_shadow: isShadow,
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobDepartment({ jobId }) {
  console.log("jobId", jobId);
  try {
    const query = {
      fields: ["department"],
      filter: {
        job: {
          _eq: jobId,
        },
      },
    };
    const response = await getItemsFromCollection("allocated_hours", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobType({ jobId }) {
  try {
    const query = {
      fields: ["type"],
      filter: {
        id: {
          _eq: jobId,
        },
      },
    };
    const response = await getItemFromCollection("jobs", jobId, query);
    console.log(response);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
